import React, { useState } from "react";
import { toast } from "sonner";
import { api, formatErr } from "../../lib/api";
import { Card } from "../onboarding/adminUi";
import { MacroTable, NutritionAlerts } from "./MacroTable";

export const LEVEL_LABEL = { none: "sin nutrición", basic: "básica", advanced: "avanzada" };

export const EssentialSelect = ({ uid, e, onChange, testid }) => {
  const [busy, setBusy] = useState(false);
  const val = e.source === "manual" ? e.level : "auto";
  const set = async (v) => {
    setBusy(true);
    try { await api.put(`/admin/nutrition/players/${uid}/level`, { value: v === "auto" ? null : v }); await onChange(); toast.success("Nivel de nutrición actualizado"); }
    catch (err) { toast.error(formatErr(err)); }
    finally { setBusy(false); }
  };
  return (
    <select className="qv-input" value={val} disabled={busy} onChange={(ev) => set(ev.target.value)} style={{ width: "auto", padding: "6px 10px", fontSize: 12 }} data-testid={testid}>
      <option value="auto">Según plan contratado{e.source !== "manual" ? ` (${LEVEL_LABEL[e.level]})` : ""}</option>
      <option value="none">Sin nutrición (manual)</option>
      <option value="basic">Básica · Essential (manual)</option>
      <option value="advanced">Avanzada · Performance (manual)</option>
    </select>
  );
};

const PlayerRow = ({ p, onChange }) => {
  const [open, setOpen] = useState(false);
  const m = p.measures;
  return (
    <div style={{ borderTop: "1px solid rgba(255,255,255,0.06)", padding: "12px 0" }} data-testid={`nutri-player-${p.id}`}>
      <div style={{ display: "flex", justifyContent: "space-between", gap: 10, flexWrap: "wrap", alignItems: "center" }}>
        <button onClick={() => setOpen(!open)} disabled={!p.essential} style={{ background: "none", border: "none", color: "#fff", textAlign: "left", cursor: p.essential ? "pointer" : "default", padding: 0 }} data-testid={`nutri-player-toggle-${p.id}`}>
          <b>{p.name}</b>
          <span style={{ fontSize: 12, color: p.essential ? "#4ade80" : "#737373", marginLeft: 8 }}>{p.level === "advanced" ? "Avanzada · Performance" : p.essential ? "Básica · Essential" : "Sin nutrición"}{p.plan_key && p.source === "plan" ? ` · plan ${p.plan_key}` : ""}</span>
          {p.essential && <span style={{ fontSize: 12, color: "#a3a3a3", marginLeft: 8 }}>{m.weight_kg ? `${m.weight_kg} kg (${m.weight_source})` : "sin peso"}{p.alerts.some((a) => a.level === "high") ? " · ⚠ alertas" : ""}</span>}
        </button>
        <EssentialSelect uid={p.id} e={p} onChange={onChange} testid={`nutri-player-essential-${p.id}`} />
      </div>
      {open && p.essential && (
        <div style={{ marginTop: 10 }}>
          <MacroTable rows={p.targets} testid={`nutri-player-table-${p.id}`} />
          <div style={{ marginTop: 8 }}><NutritionAlerts alerts={p.alerts} testid={`nutri-player-alerts-${p.id}`} /></div>
        </div>
      )}
    </div>
  );
};

export const PlayersCard = ({ players, onChange }) => (
  <Card title={`Futbolistas · ${players.filter((p) => p.essential).length} con nutrición (${players.filter((p) => p.level === "advanced").length} avanzada)`} testid="nutri-players-card">
    <div style={{ fontSize: 12, color: "#a3a3a3", marginBottom: 6 }}>Referencias calculadas con el peso más reciente registrado y tu configuración. Pulsa un futbolista con nutrición para ver sus calorías y macronutrientes por tipo de día.</div>
    {players.map((p) => <PlayerRow key={p.id} p={p} onChange={onChange} />)}
  </Card>
);
